import Srcset from "@/components/common/Srcset";
import styles from "./MobMenu.module.scss";
import { navigationTracking } from "@/components/common/Tracking";
import { useDispatch, useSelector } from "react-redux";

export default function MobileSubmenu({ menuItems, ...props }) {
  const dispatch = useDispatch();
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  return (
    <>
          {menuItems.map((menuItem,index)=>{
            return (<li className={`${index==props.index ? styles.active:''}`} key={index}>
              <a href={menuItem.navigationLink} className={`small-sm x-small-xs`} data-title={menuItem.navigationTitle} data-ga4={"Navigation " + menuItem.navigationTitle}
                onClick={
                  () => {
                    if (isPWA){
                        dispatch(setSearchIcon(false));
                        dispatch(isMenuVisible(false));
                      }
                  }
                }
              >
                        {menuItem.navigationTitle}
                      </a>
                    </li>)
          })}
    </>
  );
}
